<h1 mat-dialog-title>{{'Aide' | translate}}</h1>
<!-- Ng if est lazy rendering, il n'affiche que le case donc tout les traitement fait sur les autre case ne seront pas executé  -->
<mat-dialog-content [ngSwitch]="helperPage">
    <some-element *ngSwitchCase="CST_DIALOG_HELP_PAGE.PRINTER_HELP">
        <!-- <p></p> -->
        <ul>
            <li>
                <h2>{{'My print is cropped what sould i do ?' | translate}}</h2>
                <a href="https://helpx.adobe.com/acrobat/kb/scale-or-resize-printed-pages.html" target="_blank">See help adobe</a>
            </li>
        </ul>
    </some-element>
    <some-element *ngSwitchCase="CST_DIALOG_HELP_PAGE.CONNECTION_HELP">
        {{helperPage}}
    </some-element>
</mat-dialog-content>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close cdkFocusInitial>{{'Fermer' | translate}}</button>
</div>
